/**
 * Map active field from dto.
 * @param {string} dto Dto.
 * @returns {boolean}
 */
function fromDto(dto) {
  // (Tien Luu) To clarify the logic, we shouldn't use the shorthand syntax
  // eslint-disable-next-line no-unneeded-ternary
  return dto === 'Y' ? true : false;
}

export const activeMapper = {
  fromDto,
};
